// 封装请求
import axios from 'axios'
import QS from 'qs';
import {localData,sessionData} from "./data.js"
import { Message } from 'element-ui'

axios.defaults.baseURL = process.env.NODE_ENV === '"production"' ? process.env.VUE_APP_URL_DEVELOPMENT : process.env.VUE_APP_URL_DEVELOPMENT
axios.defaults.withCredentials = true;

// request拦截器--传输出去的内容
axios.interceptors.request.use(
	config => {
		// 每次发送请求之前判断vuex中是否存在token
		// 如果存在，则统一在http请求的header都加上token，后台根据token判断登录情况
		// 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
		var userInfoP = sessionStorage.getItem('userInfo');
		if (userInfoP) {
			var a = JSON.parse(userInfoP)
			config.headers['token'] = a.token;
			config.headers['plt'] = a.plat;
		}
		return config;
	},
	error => {
		return Promise.error(error);
	}
);
// respone拦截器--接收回来的内容
axios.interceptors.response.use(
	response => {
		// 如果返回的状态码为10000，说明接口请求成功，可以正常拿到数据
		// 否则的话抛出错误
		if (response.status === 200) {


			const res = response.data;
			if (res.code && res.code != 10000) {
				if( res.code === 10004 || res.code === 10005 || res.code === 10008){
					Message({
						message: '登录过期请求失败',
						type: 'error',
						duration: 5 * 1000
					})
					sessionStorage.clear();
					// this.$router.push({path: '/'});
					location.reload();
				}
				return Promise.resolve(response);
			} else {
				// alert('请求成功')
				return Promise.resolve(response);
			}


		} else {
			return Promise.reject(response);
		}
	},
);


//get请求
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			console.log(err)
			reject(err.data)
		})
	});
}

//post请求
export function post(url, data, headers = "") {
	if (headers != "") {
		return new Promise((resolve, reject) => {
			axios.post(url, data, {
					headers: {
						// "Content-Type": "multipart/form-data",
						'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
					}
				})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err.data)
				})
		});
	}
	return new Promise((resolve, reject) => {
		axios.post(url, QS.stringify(data))
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}



// WEBPACK FOOTER //
// ./src/utils/request.js